/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-05-05 15:48:09
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-05-05 15:59:07
 * @FilePath: /tntd/packages/tntd/src/descriptions/descriptions.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import type { DescriptionsProps as AntdDescriptionsProps } from 'antd/lib/descriptions'
import classNames from 'classnames'
import { ConfigConsumer } from 'antd/lib/config-provider'
import { default as AntdDescriptions } from 'antd/lib/descriptions'

export * from 'antd/lib/descriptions'

export interface DescriptionsProps extends AntdDescriptionsProps {
  tdType: boolean
  ellipsis: boolean
  widthAuto: boolean
}

export function Descriptions({ className, tdType, ...rest }: DescriptionsProps): JSX.Element {
  let tdDescriptions = false
  const { layout, ellipsis, widthAuto } = rest || {}
  if (layout !== 'vertical' && tdType) {
    tdDescriptions = true
  }
  return (
    <ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('descriptions')
        return (
          <AntdDescriptions
            className={classNames(
              prefixCls,
              'tntd-descriptions',
              {
                'td-descriptions': tdDescriptions,
              },
              {
                'tntd-ellipsis': ellipsis,
              },
              {
                'tntd-wrap': !ellipsis,
              },
              {
                'width-160': !widthAuto,
              },
              className
            )}
            {...rest}
          />
        )
      }}
    </ConfigConsumer>
  )
}

Descriptions.Item = AntdDescriptions.Item
